import { useEffect } from 'react';
import Header from '../../components/Header';
import HeroSection from './components/HeroSection';
import MetricsSection from './components/MetricsSection';
import FeaturesSection from './components/FeaturesSection';
import WorkflowSection from './components/WorkflowSection';
import CapabilitiesSection from './components/CapabilitiesSection';
import CaseStudiesSection from './components/CaseStudiesSection';
import IntegrationsSection from './components/IntegrationsSection';
import PricingSection from './components/PricingSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from '../../components/Footer';
import { Helmet } from 'react-helmet-async';

const AIChatbotAutomation = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
  {/* Primary SEO */}
  <title>AI Chatbot Automation Services | Make Mind Automations</title>
  <meta
    name="description"
    content="We design and deploy AI chatbots that qualify leads, answer FAQs, and support customers 24/7 on WhatsApp, web chat, and email. Done-for-you automation that saves your team 40–70 hours every month."
  />
  <meta
    name="keywords"
    content="AI chatbot automation, WhatsApp chatbot, website chatbot, support automation, lead qualification bot, OpenAI chatbot agency, automation agency"
  />
  <link
    rel="canonical"
    href="https://www.makemindautomations.tech/ai-chatbot-automation"
  />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="AI Chatbot Automation Services | Make Mind Automations"
  />
  <meta
    property="og:description"
    content="Launch AI chatbots that handle leads and customer support on autopilot across WhatsApp, web, and email."
  />
  <meta
    property="og:url"
    content="https://www.makemindautomations.tech/ai-chatbot-automation"
  />
  <meta
    property="og:image"
    content="https://www.makemindautomations.tech/og-image.jpg"
  />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta
    name="twitter:title"
    content="AI Chatbot Automation Services | Make Mind Automations"
  />
  <meta
    name="twitter:description"
    content="Done-for-you AI chatbot automation for support, sales, and lead qualification."
  />
  <meta
    name="twitter:image"
    content="https://www.makemindautomations.tech/og-image.jpg"
  />
</Helmet>


      <div className="min-h-screen bg-background">
        <Header />
        
        <main>
          <HeroSection />
          <MetricsSection />
          <FeaturesSection />
          <WorkflowSection />
          <CapabilitiesSection />
          <CaseStudiesSection />
          <IntegrationsSection />
          <PricingSection />
          <FAQSection />
          <CTASection />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default AIChatbotAutomation;